module.exports = __webpack_public_path__ + "static/media/lord-jesus-christ.a7562038.png";